import { useMemo } from 'react';
import * as boardBackgrounds from '../../components/boardBackgrounds';
import { isFavoritesBoard } from '../media-manager-sdk/boards';

export const useBoardThumbnail = (board) => {
  const { thumbnailUrl, isSystemThumbnailUrl, dataThumbnailUrl } = useMemo(() => {
    if (isFavoritesBoard(board)) {
      return { isSystemThumbnailUrl: true, thumbnailUrl: boardBackgrounds.favorites, dataThumbnailUrl: 'favorites' };
    }

    if (boardBackgrounds[board.thumbnailUrl]) {
      return {
        isSystemThumbnailUrl: true,
        thumbnailUrl: boardBackgrounds[board.thumbnailUrl],
        dataThumbnailUrl: `system-${board.thumbnailUrl}`,
      };
    }

    return { isSystemThumbnailUrl: false, thumbnailUrl: board.thumbnailUrl, dataThumbnailUrl: board.thumbnailUrl };
  }, [board]);

  return { thumbnailUrl, isSystemThumbnailUrl, dataThumbnailUrl };
};
